/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMailCancel = createReactComponent("mail-cancel", "IconMailCancel", [
  [
    "path",
    {
      d: "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M17 21l4 -4", key: "svg-2" }],
  ["path", { d: "M3 7l9 6l9 -6", key: "svg-3" }]
]);

export { IconMailCancel as default };
//# sourceMappingURL=IconMailCancel.js.map
